import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ac-form-control" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Temas Türü", -1)
const _hoisted_3 = { class: "ac-form-control" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "icon" }, "Temas Türü İkonu", -1)
const _hoisted_5 = { class: "ac-form-control mt-16" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "category" }, "Temas Türü Kategorisi", -1)
const _hoisted_7 = { class: "flex items-stretch justify-between" }
const _hoisted_8 = ["selected"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ac-button-row gap-2 flex items-center justify-center mt-8" }
const _hoisted_11 = {
  type: "submit",
  class: "ac-primary-button w-2/6"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

import type { AcMilestone } from '@/types/crm';
import { formatUser } from '../../mixins/visualFormatters';
import { useStore } from "vuex";
import { computed } from 'vue';
import { ref } from 'vue';
import acIconPicker from '../reusable/acIconPicker.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'addMilestoneTypeForm',
  props: ["existingMilestoneType", "existingMilestoneCategories"],
  emits: ["milestoneTypeAdded", "milestoneTypeUpdated", "cancelled"],
  setup(__props, { emit: __emit }) {


const store = useStore()
const user = computed(() => store.getters["user/userProfile"])
const formattedUser = formatUser(user.value)

const emits = __emit
const props = __props

const isAddingNewCategory = ref(false)

const milestoneType = ref<AcMilestone>({
    id: props.existingMilestoneType?.id ?? "",
    title: props.existingMilestoneType?.title ?? "",
    icon: props.existingMilestoneType?.icon ?? "",
    category: props.existingMilestoneType?.category ?? "",
    date: props.existingMilestoneType?.date ?? new Date(),
    user: props.existingMilestoneType?.user ?? formattedUser,
})

const toggleCategoryInput = () => {
    isAddingNewCategory.value = !isAddingNewCategory.value
    if(props.existingMilestoneType){
        milestoneType.value.category = props.existingMilestoneType.category
    } else {
        milestoneType.value.category = ""
    }
}

const handleIconSelected = (icon: string) => {
    milestoneType.value.icon = icon
}

const handleFormSubmit = () => {
    if(!milestoneType.value.title || !milestoneType.value.icon || !milestoneType.value.category){
        alert("Lütfen tüm alanları doldurunuz.")
        return
    }
    if (props.existingMilestoneType) {
        emits('milestoneTypeUpdated', milestoneType.value)
    } else {
        const { id, ...milestoneTypeWithoutId } = milestoneType.value
        console.log(id)
        emits('milestoneTypeAdded', milestoneTypeWithoutId)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleFormSubmit, ["prevent"]),
    class: "ac-main-form !border-none"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "title",
        class: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((milestoneType.value.title) = $event))
      }, null, 512), [
        [_vModelText, milestoneType.value.title]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(acIconPicker, {
        height: "300px",
        onIconSelected: handleIconSelected
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (isAddingNewCategory.value)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "text",
              id: "category",
              class: "w-[93%]",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((milestoneType.value.category) = $event))
            }, null, 512)), [
              [_vModelText, milestoneType.value.category]
            ])
          : _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 1,
              id: "category",
              class: "w-[93%] py-4",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((milestoneType.value.category) = $event))
            }, [
              _createElementVNode("option", {
                value: "",
                selected: milestoneType.value.category === ''
              }, "Lütfen bir kategori seçin veya yeni bir kategori oluşturun.", 8, _hoisted_8),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.existingMilestoneCategories, (category) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: category,
                  value: category
                }, _toDisplayString(category), 9, _hoisted_9))
              }), 128))
            ], 512)), [
              [_vModelSelect, milestoneType.value.category]
            ]),
        _createElementVNode("button", {
          type: "button",
          class: "ac-icon-button border w-[5%]",
          onClick: toggleCategoryInput
        }, _toDisplayString(isAddingNewCategory.value ? "x" : "+"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", _hoisted_11, [
        (!__props.existingMilestoneType)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Temas Türü Oluştur "))
          : (_openBlock(), _createElementBlock("span", _hoisted_13, " Temas Türü Güncelle "))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "ac-secondary-button w-2/6",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('cancelled')))
      }, "İptal")
    ])
  ], 32))
}
}

})